import { render } from "./PressearchivComponent.vue?vue&type=template&id=4aabb20e&scoped=true"
import script from "./PressearchivComponent.vue?vue&type=script&lang=js"
export * from "./PressearchivComponent.vue?vue&type=script&lang=js"

import "./PressearchivComponent.vue?vue&type=style&index=0&id=4aabb20e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aabb20e"]])

export default __exports__